<template>
  <div>
    <Modal :value="isShowModal"
           @on-ok="ok"
           @on-cancel="cancel"
           @on-visible-change="getFaultModalStatusChange">
      <Row style="padding: 24px;">
        <Col span="12" style="display: flex;align-items: center;">
          <Col span="8">费用名称</Col>
          <Col span="14">
            <Select size="small" placeholder="费用名称" clearable @on-change="handleNameChange"
                    v-model="feesData.name">
              <Option :value="item.name" v-for="(item, index) in pickAddress"
                      :key="item.name">{{ item.name }}
              </Option>
            </Select>
          </Col>
        </Col>
        <Col span="12" style="display: flex;align-items: center;">
          <Col span="8">费用数量</Col>
          <Col span="14">
            <InputNumber v-model="feesData.sum" :min="0" placeholder="费用数量"/>
          </Col>
        </Col>
      </Row>
      <!--<Row style="display: flex;justify-content: center;">
         <Button class="style4" @click="handleAdd">继续添加</Button>
      </Row>-->
    </Modal>
  </div>
</template>

<script>
export default {
  name: "FeesCom",
  props: {
    isShowModal: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      feesData: {
        name: '',
        sum: 0
      },
      pickAddress: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleNameChange() {

    },
    getList() {
      this.$Rq.requestAuth({
        url: this.$Api.listFees,
        method: 'get',
        data: {limit: 1000}
      }).then((res) => {
        if (res.code == 0) {
          this.$Utils.showSuccess(res.msg);
          this.pickAddress = res.data.data
        } else {
          this.$Utils.showTipInfo(res.msg);
          this.pickAddress = []
        }
      }).catch((err) => {
        this.$Utils.showTipInfo('网络异常');
      });
    },
    handleAdd() {

    },
    cancel() {
      this.feesData = {
        name: '',
        sum: 0
      }
      this.$emit("modalCancel");
    },
    ok() {
      console.log(this.feesData)

      this.$emit("modalSubmit", this.feesData);
    },
    getFaultModalStatusChange(e) {
      this.$emit("modalStatusChange", e);
    }
  }
}
</script>

<style scoped>

</style>
